import { render, staticRenderFns } from "./BoLogin.vue?vue&type=template&id=04919ebc&scoped=true"
import script from "./BoLogin.vue?vue&type=script&lang=js"
export * from "./BoLogin.vue?vue&type=script&lang=js"
import style0 from "./BoLogin.vue?vue&type=style&index=0&id=04919ebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04919ebc",
  null
  
)

export default component.exports